var cell_default = {
  "cell": "-rgOm",
  "header": "_7Q9v8",
  "selected": "xNHYa",
  "editing": "Wkmcp",
  "singleSelection": "MU9oB",
  "hideLastBlock": "WH0Ts",
  "editorWrapper": "aGlZY",
  "viewerWrapper": "JkwVI",
  "hideFirstBlock": "NR5i5",
  "editor": "bo6uL",
  "edit": "_6bMPD",
  "view": "j6M2Y",
  "editingToolbarWrapper": "jUaBB",
  "selectAll": "E6xol",
  "disableSelection": "xamqT"
};
export {
  cell_default as default
};
//# sourceMappingURL=cell-scss.js.map
